import { render, staticRenderFns } from "./DayOfWeekSetting.vue?vue&type=template&id=4852e3dc&scoped=true&"
import script from "./DayOfWeekSetting.vue?vue&type=script&lang=ts&"
export * from "./DayOfWeekSetting.vue?vue&type=script&lang=ts&"
import style0 from "./DayOfWeekSetting.vue?vue&type=style&index=0&id=4852e3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852e3dc",
  null
  
)

export default component.exports